module.exports = __webpack_public_path__ + "static/media/6.c92d2e89.jpg";